import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageSwitchComponent } from './language-switch.component';
import { SpeedDialModule } from 'primeng/speeddial';
import { SharedModule } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [
    LanguageSwitchComponent
  ],
  imports: [
    CommonModule,
    SpeedDialModule
  ],
  exports:[
    LanguageSwitchComponent
  ]
})
export class LanguageSwitchModule { }
